export const LsQuoteDeclineReasons = {
    capacity: "I don't have capacity",
    workType: "I don't want this type of work",
    scheduleConflicts: 'scheduling conflicts',
    jobBig: 'job is too big',
    jobSmall: 'job is too small',
    specialEquipment: 'requires special equipment',
    other: 'other',
};

// Keyed on the uppercase `ScheduleEventStatus` enum; wording matches Admin's badges.
export const LsScheduleEventStatusLabels = {
    PENDING: 'Pending',
    AWAITING_PRICE: 'Awaiting Price',
    AWAITING_CUSTOMER: 'Awaiting Customer',
    SCHEDULED: 'Scheduled',
    COMPLETED: 'Completed',
};

// `statusReason` is a raw lowercase DB string, unlike the uppercase `status` above.
export const LsScheduleEventCancelledReasonLabels = {
    declined: 'Declined',
    expired: 'Expired',
    cancelled: 'Cancelled',
    // Moved to another Pro rather than ended. Without this it reads as Cancelled.
    redistributed: 'Redistributed',
};

// Keyed on the serialized enum name, not the lowercase DB string. Title Case because these
// render as standalone list items.
export const LsProDeclineReasonLabels = {
    NO_CAPACITY: "I don't have capacity",
    WORK_TYPE: "I don't want this type of work",
    SEASON: 'Out of season',
    SCHEDULE_CONFLICT: 'Scheduling conflicts',
    JOB_TOO_BIG: 'Job is too big',
    JOB_TOO_SMALL: 'Job is too small',
    SPECIAL_EQUIPMENT: 'Requires special equipment',
    OTHER: 'Other',
};

// Keyed on the uppercase `ManualPriceDeclineReason` enum name, same as the Provider map above.
export const LsCustomerDeclineReasonLabels = {
    TOO_EXPENSIVE: 'Too expensive',
    WILL_DO_MYSELF: 'Will do it myself',
    WILL_HIRE_SOMEONE_ELSE: 'Will hire someone else',
    NO_LONGER_NEEDED: 'No longer needed',
    JUST_WANTED_PRICE: 'Just wanted a price',
    OTHER: 'Other',
};
